import axios from "axios";
import { decryptResponse, encryptRequest } from "./encryption";
export const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_API,
});

axiosApi.defaults.headers.common[
  "Authorization"
] = `Bearer ${localStorage.getItem("token")}`;


axiosApi.interceptors.request.use(
  (config) => {
    if (config.data && typeof config.data === 'object') {
      const encryptedData = encryptRequest(config.data);
      config.data = encryptedData;
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosApi.interceptors.response.use(
  (response) => decryptResponse(response?.data),
  (error) => {
    const statusCode = error?.response?.status;
    // if (statusCode === 401) {
    //   window.location = '/landing';
    //   localStorage.clear();
    //   location.reload();
    // }
    return Promise.reject(error);
  }
);
